module.exports = __webpack_public_path__ + "img/sleeve ruffle length.b6d4b80d.png";